module.exports = __webpack_public_path__ + "static/prepped-desktop-2-0eb5fe2f6a763d990f66773b61b96dc7.jpg";